import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'

import { pushToGTM } from '../../shared/utis/gtm'
import styles from './CentralAsiaReportRedirect.module.scss'

const PDF_URL = process.env.NODE_ENV === 'production' ? '/assets/doc.pdf' : '/doc/doc.pdf'

const CentralAsiaReportRedirect = () => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: '/reports/central-asia-caspian-report-2026' })
    pushToGTM({
      event: 'ca_report',
      tagName: 'Central Asia and Caspian Report 2026 PDF',
      title: 'Urus Advisory Central Asia and Caspian Report 2026 Digital',
    })
    const t = setTimeout(() => {
      window.location.href = PDF_URL
    }, 400)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Opening PDF…</p>
      <p className={styles.fallback}>
        If it doesn’t open,{' '}
        <a href={PDF_URL} className={styles.link}>
          click here
        </a>
      </p>
    </div>
  )
}

export default CentralAsiaReportRedirect
